import React from "react";

interface ComingSoonProps {
  feature?: string;
  description?: string;
}

/**
 * Polite placeholder for routes that are reserved but not yet shipped.
 * Replaces raw 404s on routes named in the brand vocabulary but not yet wired.
 * Canon-locked: gray surfaces only, no exclamation points, no emojis, M-PACT hyphenated.
 */
export default function ComingSoon({ feature, description }: ComingSoonProps) {
  return (
    <div
      style={{
        minHeight: "60vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "48px 24px",
        background: "#FAFAFA",
      }}
    >
      <div
        style={{
          maxWidth: 520,
          padding: "40px 32px",
          background: "#FFFFFF",
          border: "1px solid #E5E7EB",
          borderRadius: 8,
          textAlign: "center",
          boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
        }}
      >
        <div
          style={{
            fontSize: 12,
            fontWeight: 600,
            letterSpacing: "0.08em",
            textTransform: "uppercase",
            color: "#6B7280",
            marginBottom: 16,
          }}
        >
          Coming soon
        </div>
        <h1
          style={{
            fontSize: 24,
            fontWeight: 600,
            color: "#111827",
            margin: "0 0 12px",
            lineHeight: 1.3,
          }}
        >
          {feature ?? "This view is on the roadmap"}
        </h1>
        <p
          style={{
            fontSize: 15,
            color: "#4B5563",
            margin: "0 0 24px",
            lineHeight: 1.5,
          }}
        >
          {description ??
            "We are rolling features out in waves. This surface is reserved and will ship in a follow-on release."}
        </p>
        <a
          href="/#/"
          style={{
            display: "inline-block",
            padding: "10px 20px",
            background: "#374151",
            color: "#FFFFFF",
            borderRadius: 6,
            textDecoration: "none",
            fontSize: 14,
            fontWeight: 500,
          }}
        >
          Back to home
        </a>
      </div>
    </div>
  );
}
